export default class PagesClass {

	static init() {
      // alert('onInit PagesClass');
    }

}